import { gql } from '@apollo/client'
import { checkout } from './fragments'
import IShopifyCheckout from '../../domains/shopify/ShopifyCheckout'

const query = gql`
  query checkout($checkoutId: ID!) {
    node(id: $checkoutId) {
      ...ShopifyCheckout
    }
  }
  ${checkout}
`

/**
 * https://help.shopify.com/en/api/storefront-api/reference/mutation/checkoutlineitemsreplace
 *
 * @param {{ checkoutId: string}} variables
 */
const queryCheckout = (
  client: any,
  variables: { checkoutId: string },
): Promise<{
  data: {
    node: IShopifyCheckout
  }
}> => client.query({ query, variables })

export default queryCheckout
